export default "__VITE_ASSET__ChdRrBOy__"